import { v4 as uuidv4 } from 'uuid';

import { createInteractionCategorySelectOption } from 'CorePackage/CatalogsModule/common/createInteractionCategorySelectOption';
import { getDictionarySelectOptionWithState } from 'CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { IKnmErknmFormEventUav } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormUav';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { createSubmittedDocuments } from 'KnmPackage/MainModule/common/createSubmittedDocuments';
import { IKnmEvent248 } from 'APIPackage/KnmModule/interfaces/IKnmEvent248';
import { IKnmPmForm } from 'KnmPmPackage/MainModule/interfaces/IKnmPmForm';
import { IUavTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUavTypeSelectOption';

export const convertInitialEventsPmDataToFormValues = (
  state: IRootState,
  initialEvents: IKnmEvent248[] | null | undefined,
  initialFormValues: IKnmPmForm,
  uavTypeSelectOptions: IUavTypeSelectOption[],
): IKnmErknmFormEvent[] | undefined => {
  return initialEvents?.map((item, index) => {
    const selectOption = item.event?.dictId
      ? getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.EVENT_TYPE>(
          state,
          item.event?.dictId,
          item.event?.dictVersionId,
        )
      : undefined;
    const formEvent: IKnmErknmFormEvent = {
      type: selectOption && {
        ...selectOption,
        inspectionResult: item.event?.inspectionResult,
      },
      ...(!selectOption && initialFormValues.eventsPm?.[index]),
      guid: item.guid,
      startDate: convertInitialKnmDateToFormDate(item.startDate, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
      stopDate: convertInitialKnmDateToFormDate(item.stopDate, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
      dateCreate: item.dateCreate,
      listId: item?.guid || uuidv4(),
      interactionCategory: item?.interactionCategory
        ? createInteractionCategorySelectOption(item.interactionCategory)
        : undefined,
      isNew: !!item.isNew,
      originalStopDate: item.originalStopDate || undefined,
      submittedDocuments: createSubmittedDocuments(item.submittedDocuments),
      isFilledFromLink: item.isFilledFromLink || undefined,
      isUavUsed: (item?.uavTechnologies && item.uavTechnologies?.length > 0) || false,
      uavTechnologies: item?.uavTechnologies?.map(x => {
        const eventUavForm: IKnmErknmFormEventUav = {
          guid: x.guid || uuidv4(),
          isNew: false,
          listId: uuidv4(),
          name: x.name || undefined,
          type: uavTypeSelectOptions.find(uavType => uavType.id === x.typeId) || undefined,
        };

        return eventUavForm;
      }),
      eventCopyNumber: item.eventCopyNumber || undefined,
      experts: undefined,
    };

    return formEvent;
  });
};
